/* eslint-disable no-param-reassign */
import isArray from 'lodash/isArray';
import * as WindowHelper from '@Services/WindowHelper';
import * as QbHelpers from '@Services/QBHelpers';

const DRAG_ELEMENT_HEIGHT = 60;
const ANIMATION_DURATION = 100;


/**
 * @name insertByIndex
 * @param {Array} array
 * @param {Object} obj
 * @param {Object} index
 * @description insert by index
 */
export const insertByIndex = (array, obj, index) => {
  if (isArray(obj)) {
    // forms grouped array, must not rewrite, but to add each new item
    const args = [index, 0].concat(obj);
    // eslint-disable-next-line prefer-spread
    array.splice.apply(array, args);
    return;
  }
  if (index === -1) {
    array.push(obj);
    return;
  }
  if (index === 0 && obj.isShell) {
    array.push(obj);
    return;
  }
  array.splice(index, 0, obj);
};
